module.exports = __webpack_public_path__ + "img/gallery-9.a2880698.jpg";